import { all } from 'redux-saga/effects';
import { onFetchFilters } from './filter/priceCalendarFilterOperations';
import { onReceiveFiltersSuccess, onSetMonth } from '@state/price-calendar/monthly/priceCalendarMonthlyOperations';

export function* combinedPriceCalendarSagas() {
  yield all([onFetchFilters(), onReceiveFiltersSuccess(), onSetMonth()]);
}
